/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RunClusterOptimizationsReportRequestFilter } from '../models';
// @ts-ignore
import type { RunClusterOptimizationsReportResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * OptimizationAPIApi - axios parameter creator
 * @export
 */
export const OptimizationAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns optimization reports for clusters including utilization metrics and autoscaler suggestions.
         * @summary Returns cluster optimizations report
         * @param {string} organizationId ID of the organization.
         * @param {RunClusterOptimizationsReportRequestFilter} runClusterOptimizationsReportRequestFilter 
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizationAPIRunClusterOptimizationsReport: async (organizationId: string, runClusterOptimizationsReportRequestFilter: RunClusterOptimizationsReportRequestFilter, pageLimit?: string, pageCursor?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('optimizationAPIRunClusterOptimizationsReport', 'organizationId', organizationId)
            // verify required parameter 'runClusterOptimizationsReportRequestFilter' is not null or undefined
            assertParamExists('optimizationAPIRunClusterOptimizationsReport', 'runClusterOptimizationsReportRequestFilter', runClusterOptimizationsReportRequestFilter)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/clusters:runOptimizationsReport`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (pageLimit !== undefined) {
                localVarQueryParameter['page.limit'] = pageLimit;
            }

            if (pageCursor !== undefined) {
                localVarQueryParameter['page.cursor'] = pageCursor;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(runClusterOptimizationsReportRequestFilter, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OptimizationAPIApi - functional programming interface
 * @export
 */
export const OptimizationAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OptimizationAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns optimization reports for clusters including utilization metrics and autoscaler suggestions.
         * @summary Returns cluster optimizations report
         * @param {string} organizationId ID of the organization.
         * @param {RunClusterOptimizationsReportRequestFilter} runClusterOptimizationsReportRequestFilter 
         * @param {string} [pageLimit] Defines the number of items that should be returned
         * @param {string} [pageCursor] Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async optimizationAPIRunClusterOptimizationsReport(organizationId: string, runClusterOptimizationsReportRequestFilter: RunClusterOptimizationsReportRequestFilter, pageLimit?: string, pageCursor?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RunClusterOptimizationsReportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.optimizationAPIRunClusterOptimizationsReport(organizationId, runClusterOptimizationsReportRequestFilter, pageLimit, pageCursor, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['OptimizationAPIApi.optimizationAPIRunClusterOptimizationsReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * OptimizationAPIApi - factory interface
 * @export
 */
export const OptimizationAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OptimizationAPIApiFp(configuration)
    return {
        /**
         * Returns optimization reports for clusters including utilization metrics and autoscaler suggestions.
         * @summary Returns cluster optimizations report
         * @param {OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        optimizationAPIRunClusterOptimizationsReport(requestParameters: OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReportRequest, options?: RawAxiosRequestConfig): AxiosPromise<RunClusterOptimizationsReportResponse> {
            return localVarFp.optimizationAPIRunClusterOptimizationsReport(requestParameters.organizationId, requestParameters.runClusterOptimizationsReportRequestFilter, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for optimizationAPIRunClusterOptimizationsReport operation in OptimizationAPIApi.
 * @export
 * @interface OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReportRequest
 */
export interface OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReportRequest {
    /**
     * ID of the organization.
     * @type {string}
     * @memberof OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReport
     */
    readonly organizationId: string

    /**
     * 
     * @type {RunClusterOptimizationsReportRequestFilter}
     * @memberof OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReport
     */
    readonly runClusterOptimizationsReportRequestFilter: RunClusterOptimizationsReportRequestFilter

    /**
     * Defines the number of items that should be returned
     * @type {string}
     * @memberof OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReport
     */
    readonly pageLimit?: string

    /**
     * Cursor that defines token indicating where to start the next page.  Empty value indicates to start from beginning of the dataset.
     * @type {string}
     * @memberof OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReport
     */
    readonly pageCursor?: string
}

/**
 * OptimizationAPIApi - object-oriented interface
 * @export
 * @class OptimizationAPIApi
 * @extends {BaseAPI}
 */
export class OptimizationAPIApi extends BaseAPI {
    /**
     * Returns optimization reports for clusters including utilization metrics and autoscaler suggestions.
     * @summary Returns cluster optimizations report
     * @param {OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptimizationAPIApi
     */
    public optimizationAPIRunClusterOptimizationsReport(requestParameters: OptimizationAPIApiOptimizationAPIRunClusterOptimizationsReportRequest, options?: RawAxiosRequestConfig) {
        return OptimizationAPIApiFp(this.configuration).optimizationAPIRunClusterOptimizationsReport(requestParameters.organizationId, requestParameters.runClusterOptimizationsReportRequestFilter, requestParameters.pageLimit, requestParameters.pageCursor, options).then((request) => request(this.axios, this.basePath));
    }
}

